export default __webpack_public_path__ + "48bc74a22f8795def61a2591b38186b6.svg";